module.exports = __webpack_public_path__ + "static/media/covid-19.4b69b94a.png";